var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilmStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 191,
    viewBox: "0 0 135 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.452 29.7134H-26.2865C-29.4387 29.7134 -32.4618 30.9656 -34.6907 33.1945C-36.9197 35.4235 -38.1719 38.4465 -38.1719 41.5987V148.567C-38.1719 151.719 -36.9197 154.742 -34.6907 156.971C-32.4618 159.2 -29.4387 160.452 -26.2865 160.452H104.452C107.605 160.452 110.628 159.2 112.857 156.971C115.086 154.742 116.338 151.719 116.338 148.567V41.5987C116.338 38.4465 115.086 35.4235 112.857 33.1945C110.628 30.9656 107.605 29.7134 104.452 29.7134ZM-26.2865 65.3694H33.1403V124.796H-26.2865V65.3694ZM45.0256 53.4841V41.5987H68.7963V53.4841H45.0256ZM33.1403 53.4841H9.36954V41.5987H33.1403V53.4841ZM33.1403 136.682V148.567H9.36954V136.682H33.1403ZM45.0256 136.682H68.7963V148.567H45.0256V136.682ZM45.0256 124.796V65.3694H104.452V124.796H45.0256ZM104.452 53.4841H80.6817V41.5987H104.452V53.4841ZM-2.51581 41.5987V53.4841H-26.2865V41.5987H-2.51581ZM-26.2865 136.682H-2.51581V148.567H-26.2865V136.682ZM104.452 148.567H80.6817V136.682H104.452V148.567Z",
    fill: "#252B21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmStrip);
export default __webpack_public_path__ + "static/media/FilmStrip.cd04a9fe7095479bd822574ed7dd443a.svg";
export { ForwardRef as ReactComponent };